var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PageContent',{attrs:{"title":_vm.$t('propertyDetailsJSON.title')}},[_c('json-box',{attrs:{"value":_vm.unit}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }